export default __webpack_public_path__ + "static/media/HelveticaNeueLTStd-Th.cced47b8.woff";